// @flow
import React from 'react';
import 'isomorphic-fetch';
import { toastr } from 'react-redux-toastr';

import { generateApiUrl } from './apiEndPoints';
import {
  setAuthHeader,
  appUpdateWarnings,
  isBearerTokenPresent,
  getCookie,
  strUsables,
  authTokenUpdateWarnings,
  getFileNameFromContentDisposition
} from '../helpers';

// eslint-disable-next-line
export const makeApiCall = (apiCallObj: Object) => {
  const url = generateApiUrl(apiCallObj);
  const apiConfig: Object = {
    method: apiCallObj.method || 'GET',
    headers: apiCallObj.headersData ? apiCallObj.headersData : {},
    mode: 'cors',
    cache: 'default'
  };

  if (isBearerTokenPresent()) {
    const cookieBearerToken = getCookie(strUsables.accessToken);
    const sessionBearerToken = sessionStorage.getItem(strUsables.accessToken);
    if (cookieBearerToken === sessionBearerToken) {
      apiConfig.headers.Authorization = setAuthHeader(sessionBearerToken);
    } else {
      const refreshConfirmed = window.confirm(authTokenUpdateWarnings.message);
      if (refreshConfirmed === true) {
        window.location.reload(true);
        return null;
      }
      console.log('refresh cancelled');
      return null;
    }
  }

  apiConfig.headers.appName = 'zoom_panel'; // Hard-coded
  apiConfig.headers.appVersion = (process.env && process.env.NODE_VERSION) || 1;

  if (!apiCallObj.postFormData) {
    apiConfig.headers['Content-Type'] =
      apiCallObj.contentType || 'application/json';
  } else if (apiCallObj.postFormData) {
    apiConfig.body = apiCallObj.data;
    if (apiCallObj.contentType) {
      apiConfig.headers['Content-Type'] =
        apiCallObj.contentType || 'application/json';
    }
  }

  if (
    apiCallObj.method !== 'GET' &&
    apiCallObj.data &&
    !apiCallObj.postFormData
  ) {
    apiConfig.body = JSON.stringify(apiCallObj.data);
  }

  return fetch(url, apiConfig)
    .then(response => {
      if (response.status === 205) {
        // eslint-disable-next-line
        const refreshConfirmed = window.confirm(appUpdateWarnings.message);
        if (refreshConfirmed === true) {
          throw new Error(appUpdateWarnings.refreshRequiredConfirm);
        }
        throw new Error(appUpdateWarnings.refreshRequiredCancel);
      }
      if (response.status >= 400) {
        if (response.body) {
          return response.json();
        }
        throw new Error('Bad response from server');
      }
      /**
       * if fetchFileNameFromContentDisposition is set to true , file name is extracted from content-disposition header
       */

      if (apiCallObj.fetchFileNameFromContentDisposition) {
        apiCallObj.fileName = getFileNameFromContentDisposition(response);
      }
      if (apiCallObj.responseType === 'arraybuffer') {
        return response.arrayBuffer();
      }
      if (apiCallObj.responseType === 'blob') {
        return response;
      }
      return response.json();
    })
    .then(resData => {
      if (resData) {
        if (
          resData &&
          resData.status === 'FAILURE' &&
          apiCallObj.apiEndPoint !== 'epodSendOtp'
        ) {
          if (!apiCallObj.notShowPopupOnError) {
            displayErrorMessage(resData);
          }
        }
        if (apiCallObj.successCb) {
          apiCallObj.successCb(resData);
        }
      } else if (apiCallObj.failureCb) {
        apiCallObj.failureCb();
      }
      return resData;
    })
    .catch(e => {
      if (e.message === appUpdateWarnings.refreshRequiredConfirm) {
        window.location.reload(true);
      } else if (e.message === appUpdateWarnings.refreshRequiredCancel) {
        // eslint-disable-next-line
        console.log('refresh cancelled');
      } else if (apiCallObj.catchCb) {
        apiCallObj.catchCb();
      }
      return e;
    });
};

const displayErrorMessage = resData => {
  const errorDetails = resData.errorDetails || [];
  let code = '';
  let title = '';
  const errorList = (errorDetails || []).map((error, index) => {
    if (index === 0) {
      code = error.code || '';
      title = error.title || '';
    }
    if (errorDetails && errorDetails.length === 1) {
      return <div style={{ maxWidth: '200px' }}>{error.description}</div>;
    }
    return <li style={{ maxWidth: '200px' }}>{error.description}</li>;
  });
  const toastrOptions = {
    timeOut: 4000,
    closeOnToastrClick: false,
    component: (
      <div style={{ wordWrap: 'break-word', fontSize: '1.4rem' }}>
        <h2>{title || 'Error'}</h2>
        {errorDetails && errorDetails.length === 1 ? (
          <div style={{ fontSize: '1.6rem' }}>{errorList}</div>
        ) : (
          <ul style={{ margin: '0', padding: '0', fontSize: '1.6rem' }}>
            {errorList}
          </ul>
        )}
        <div
          style={{ marginTop: '2rem', fontSize: '1.2rem', fontWeight: 'bold' }}
        >
          {code && <div>Error Code: {code}</div>}
          <div style={{ marginTop: '0.6rem' }}>
            Request Id : {resData.requestId}
          </div>
        </div>
      </div>
    )
  };

  toastr.error('', toastrOptions);
};
